import { type CodeBlockNode } from './types';

/**
 * Parses individual lines into CodeBlockNode objects
 */
export class LineParser {
  constructor(private colorDefinitions: Map<string, string>) {}

  parseLine(line: string, currentIndent: number): CodeBlockNode | null {
    const trimmed = line.trim();

    if (!trimmed || trimmed === '@code' || trimmed === '@code-end') {
      return null;
    }

    return (
      this.parseControlBlock(trimmed, currentIndent) ||
      this.parseCodeBlock(trimmed, currentIndent) ||
      this.parseRegularContent(trimmed, currentIndent)
    );
  }

  private parseControlBlock(trimmed: string, indent: number): CodeBlockNode | null {
    const controlTypes: Record<string, string> = {
      '@repeat': 'repeat',
      '@if': 'if',
      '@elseif': 'elseif',
      '@else': 'else',
      '@end': 'end',
    };

    for (const [prefix, type] of Object.entries(controlTypes)) {
      if (trimmed === prefix || trimmed.startsWith(prefix)) {
        const controlColor = this.colorDefinitions.get('control') || 'gray';
        return {
          type: 'control',
          controlType: type,
          color: controlColor,
          children: [],
          indent,
        };
      }
    }

    return null;
  }

  private parseCodeBlock(trimmed: string, indent: number): CodeBlockNode | null {
    if (!trimmed.startsWith('@block')) return null;

    const colorMatch = trimmed.match(/@block\[color=([^\]]+)\]/);
    let color = 'gray';

    if (colorMatch) {
      const colorKey = colorMatch[1].replace(/"/g, ''); // Remove quotes if present
      color = this.colorDefinitions.get(colorKey) || colorKey;
    }

    return {
      type: 'code',
      color,
      content: '',
      children: [],
      indent,
    };
  }

  private parseRegularContent(trimmed: string, indent: number): CodeBlockNode {
    return {
      type: 'code',
      content: trimmed,
      color: '',
      children: [],
      indent,
    };
  }
}
